import actionCreatorFactory from 'typescript-fsa';

import reduxConfig from '../../config';
import { Group } from '../../entities/group/group.types';

const actionCreator = actionCreatorFactory(reduxConfig.appName + '/appFeedGroup');

export const setEditGroup = actionCreator<Group>('SET_EDIT_GROUP');

export const updateHeadCount = actionCreator<void>('UPDATE_HEAD_COUNT');
export const updateDaysOnRation = actionCreator<void>('UPDATE_DAYS_ON_RATION');
export const updateGlobalFeedFactor = actionCreator<void>('UPDATE_GLOBAL_FEED_FACTOR');
export const lockFeeding = actionCreator<void>('LOCK_FEEDING');
export const updateLoadWeight = actionCreator<void>('UPDATE_LOAD_WEIGHT');
export const updateLoadWeightDry = actionCreator<void>('UPDATE_LOAD_WEIGHT_DRY');
export const updateFeedingFactor = actionCreator<void>('UPDATE_FEEDING_FACTOR');
export const updateFeedings = actionCreator<void>('UPDATE_FEEDINGS');

export const previewEditFeedGroup = actionCreator.async<{}, Group>('PREVIEW_EDIT_GROUP');
export const clearPreview = actionCreator('CLEAR_PREVIEW');
export const setUseLockedFeedings = actionCreator<boolean>('SET_USE_LOCKED_FEEDINGS');
export const setResultPercentage = actionCreator<{}>('SET_RESULT_PERCENTAGE');
export const setResultWeight = actionCreator<{}>('SET_RESULT_WEIGHT');
export const setGradeId = actionCreator<{}>('SET_GRADE_ID');
export const getAllBunkReaderNotes = actionCreator<{}>('GET_ALL_BUNKREADER_NOTES');
